import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { deleteFromS3 } from '../../lib/s3'

const deleteRecipeSchema = z.object({
  recipeId: z.string().min(1),
})

export const deleteRecipe = createServerFn({ method: 'POST' })
  .inputValidator(deleteRecipeSchema)
  .handler(async (ctx): Promise<{ success: boolean }> => {
    const { recipeId } = ctx.data
    try {
      await deleteFromS3(`recipes/${recipeId}.json`)
      return { success: true }
    } catch (error: any) {
      throw new Error(error.message || 'Failed to delete recipe')
    }
  })
